<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">{{name}}</h1>

                    <a :href="`/#/admin/organizations/workspaces/manage/${id}`" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>

                    <button @click="handleDeleteWorkspaceCommandV1" class="btn btn-link btn-sm">
                        <i class="fa fa-remove" aria-hidden="true"></i>
                        <span>Delete this workspace</span>
                    </button>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="form-group">
                <label for="Name">Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of workspace">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="Description">Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of workspace"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="StartupUrl">Startup url:</label>
                <input v-model="startupUrl" type="text" class="form-control" placeholder="Startup url - only for advanced scenarios">
                <ValidationError context="StartupUrl" :errors="validationErrors"></ValidationError>
            </div>

            <button v-show="!invoking" @click="invokeUpdateWorkspaceCommandV1" type="button" class="btn btn-primary btn-lg">Update</button>
            <button v-show="invoking" type="button" class="btn btn-primary btn-lg">Updating...</button>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useAdminEditWorkspacePage } from '@Organizations/Workspaces/Domain/pages-core'
    import '@common/Components/ValidationError.vue'

    const id = useRoute().params.id

    const name = ref()
    const description = ref()
    const startupUrl = ref()

    const { useWorkspaceDetailsQuery, useUpdateWorkspaceCommand, useDeleteWorkspaceCommand } = useAdminEditWorkspacePage()

    const { modelWorkspaceDetailsQueryV1, runWorkspaceDetailsQueryV1 } = useWorkspaceDetailsQuery(id)
    const { invokeUpdateWorkspaceCommandV1, succeedUpdateWorkspaceCommandV1, invoking, validationErrors } = useUpdateWorkspaceCommand(id, name, description, startupUrl)
    const { invokeDeleteWorkspaceCommandV1, succeedDeleteWorkspaceCommandV1 } = useDeleteWorkspaceCommand(id)

    const tid = computed(() => modelWorkspaceDetailsQueryV1.value?.OrganizationUnitId)
    const originalName = computed(() => modelWorkspaceDetailsQueryV1.value?.Name)

    function handleDeleteWorkspaceCommandV1() {
        if (confirm(`Do you want to delete '${originalName.value}' workspace?`)) {
            invokeDeleteWorkspaceCommandV1()
        }
    }

    onMounted(() => {
        runWorkspaceDetailsQueryV1()
    })

    watch(modelWorkspaceDetailsQueryV1, () => {
        name.value = modelWorkspaceDetailsQueryV1.value?.Name
        description.value = modelWorkspaceDetailsQueryV1.value?.Description
        startupUrl.value = modelWorkspaceDetailsQueryV1.value?.StartupUrl
    })

    watch(name, () => {
        document.title = name.value
    })

    watch(succeedUpdateWorkspaceCommandV1, succeed => {
        if (succeed) {
            location.href = `/#/admin/organizations/workspaces/manage/${id}`
        }
    })

    watch(succeedDeleteWorkspaceCommandV1, succeed => {
        if (succeed) {
            location.href = `/#/admin/organizations/workspaces/${tid.value}`
        }
    })
</script>
